import type { UseMutationResult } from 'react-query';
import { useMutation, useQueryClient } from 'react-query';

import type {
  IApiCreateAdRequestBody,
  IApiCreateAdResponseBody,
} from '../AdsApi.types';
import { useApi } from '~/lib/api/useApi';
import { adQueryKeyFactory } from './useAdQuery';
import { adsQueryKeyFactory } from './useAdsQuery';

export type IUseCreateAdMutationValues = {
  appId: string;
  body: IApiCreateAdRequestBody;
};

export const useCreateAdMutation = (): UseMutationResult<
  IApiCreateAdResponseBody,
  unknown,
  IUseCreateAdMutationValues
> => {
  const api = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (values: IUseCreateAdMutationValues) =>
      api.ads.create(values.appId, values.body),
    onSuccess: async (createdAd, values) => {
      const queryKey = adQueryKeyFactory({
        appId: createdAd.appId,
        adId: createdAd._id,
      });
      if (queryKey) {
        queryClient.setQueryData(queryKey, createdAd);
      }
      await queryClient.invalidateQueries({
        queryKey: adsQueryKeyFactory({ appId: values.appId }),
      });
    },
  });
};
